<template>
  <the-new-header></the-new-header>

  <section class="noInfo-section" v-for="(e, i) in $store.getters['noInfo/finalNoInfo']" :key="i">
    <base-info-bar>
      <router-link to="/no-info" style="color: black;">{{ e.title }}</router-link>
    </base-info-bar>

    <left-banner-template title="PAGE NOT FOUND" class="content">
      <h3 style="margin-bottom: 40px;">{{ e.content }} <router-link class="link-home" to="/" >{{ e.link }}</router-link> ? </h3>
    </left-banner-template>
  </section>

  <the-footer></the-footer>
</template>

<style scoped>
.noInfo-section {
  padding: 0 170px;
  min-height: 525px;
}

.noInfo-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.noInfo-section span{
  font-weight: 800;
}

.content a {
  text-decoration: underline;
  transition: all 0.3s ease;
}

.content a:hover {
  color: #ffde58;
}

@media (max-width: 1356px) {
  .noInfo-section {
    padding: 0 100px;
  }
}

@media (max-width: 1080px) {
  .noInfo-section {
    padding: 0 50px;
  }
}

@media (max-width: 720px) {
  .noInfo-section {
    padding: 0px 20px;
  }
}
</style>
